export default __webpack_public_path__ + "static/media/expansion_disabled.8b57d919.svg";